<template>
	<div class="assessment-toolbar-wrapper elevation-1">	
		<div class="assessment-toobar pr-10 pl-6 pt-2 pb-0 mb-0"  :style="styles">
			<v-row v-if="response">
				<ThemeCompletionRate :response="response" :question="question" theme="Struktur">
					<template v-slot:content>
						<v-card-text>
							Im Themenbereich Strukturen werden digitale Fähigkeiten und die Verfügbarkeit technischer Ressourcen, Tools, Programme und struktureller Rahmenbedingungen erfasst.
						</v-card-text>
					</template>
				</ThemeCompletionRate>
				<ThemeCompletionRate :response="response" :question="question" theme="Prozess">
					<template v-slot:content>
						<v-card-text>
							Im Erhebungsteil Prozesse wird erfasst, in welchem Umfang Informationstechnologie zur Unterstützung medizinischer, pflegerischer, therapeutischer und administrativer Prozesse genutzt wird.
						</v-card-text>
					</template>
				</ThemeCompletionRate>
				<ThemeCompletionRate :response="response" :question="question" theme="Ergebnis">
					<template v-slot:content>
						Im Modul Ergebnisse wird erfasst, inwiefern die genutzten Informationssysteme von den Anwendern vor dem Hintergrund der einrichtungs- und bereichsspezifischen Erfordernisse als nützlich und nutzenstiftend eingeschätzt werden

					</template>
				</ThemeCompletionRate>
				<v-col cols="12" md="3">
					<v-btn block small rounded color="primary" @click="() => { navigation == 0 ? navigation = null : navigation = 0 }">
						Erhebungsübersicht
						<v-icon>{{ navigation == null ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-expansion-panels id="section_navigation" flat v-if="question" v-model="navigation">
				<v-expansion-panel key="1">
					<v-expansion-panel-content  color="transparent" :eager="true">
						<SectionNavigation v-on:close="closeNav" :current="question.cn_heading" class="pa-0 pt-2" :response="response"></SectionNavigation>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<div v-if="navigation == null && question">
				
				<SectionToolbar :section="question.cn_heading" :response="response"></SectionToolbar> 
				<p class="caption">
					{{question.title}}
				</p >
			</div>

		</div>
	</div>
</template>

<style lang="less">
	#section_navigation {
		.theme--light.v-expansion-panels .v-expansion-panel{
			background-color: transparent !important;
		}
		.v-expansion-panel, .v-expansion-panel-header {
			// padding: 0px !important;
		}		
		.v-expansion-panel-content__wrap{
			// padding: 0px !important;
			font-size: 0.8em !important;
		}
	}
	.assessment-toolbar-wrapper{
		position: fixed;
		z-index: 5;
		background-color: #FAFAFD;
		margin-left: -30px !important;
		top: 0;
		// height: 100px;
		margin-top: 55px;
		width: 200%;
		overflow: hidden;		
	}
	.assessment-toobar{
		width: 100%;	
	}
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import ScoreBadge from "@/components/assessment/content/ScoreBadge"
	import SectionNavigation from "@/components/assessment/SectionNavigation"
	import SectionToolbar from "@/components/assessment/SectionToolbar"
	import ThemeCompletionRate from "@/components/assessment/content/ThemeCompletionRate"
	export default {
		name: "AssessmentToolbar", 
		props: [
			"response", "question"
		],
		data: () => {
			return {
				navigation: null,
				width: 1000,
			}
		},
		components: {
			// ScoreBadge,
			ThemeCompletionRate,
			SectionToolbar,
			SectionNavigation,
		},
		computed: {
			styles(){
				var object = {}
				object["max-width"] = this.width - 5 + "px"
				return object;
			}
			// ...Vuex.mapState({})
		},
		methods: {
			closeNav(){
				this.navigation = null
			},
			setWidth(){
				var elem = document.getElementById("assessment-wrapper");
				if( elem ){				
					this.width = elem.offsetWidth + 90;
				}
			}
		},
		created(){
			this.setWidth();
			window.onresize = this.setWidth;	
		},
		mounted(){
			this.setWidth();			
		}

	}
</script>